import React, { useEffect, useState } from "react";
import "./style.scss";
import { RightArrow } from "assets/icons";
import Button from "components/BaseWidgets/button";
import Tag from "components/BaseWidgets/tag";
import EmptyState from "components/BaseWidgets/emptyState";
import Skeleton from "components/BaseWidgets/skeleton";

const calculateTimeLeft = () => {
  const now = new Date();
  const tomorrow = new Date(now);

  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);

  const totalSeconds = Math.floor((tomorrow - now) / 1000);

  if (totalSeconds <= 0) {
    return { hours: 0, minutes: 0, seconds: 0 };
  }

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { hours, minutes, seconds };
};

function OverviewBlock({
  cardTitle,
  cardDesc,
  cardComponent,
  showTimer = false,
  cardTitleIcon,
  seeAllBtn = true,
  href = "#",
  onClick,
  className,
  seeAllClick,
  data = [],
  isLoading,
}) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [timerExpired, setTimerExpired] = useState(false);

  // Timer function
  useEffect(() => {
    if (!showTimer) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        // Convert current time to total seconds
        let totalSeconds =
          prevTime.hours * 3600 + prevTime.minutes * 60 + prevTime.seconds;

        // Decrement by 1 second
        totalSeconds -= 1;

        // If timer reaches zero, clear interval and mark as expired
        if (totalSeconds < 0) {
          clearInterval(timer);
          setTimerExpired(true);
          return { hours: 0, minutes: 0, seconds: 0 };
        }

        // Convert back to hours, minutes, seconds
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return { hours, minutes, seconds };
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [showTimer]);

  // Timer format
  const formatTime = (time) => {
    return time.toString().padStart(2, "0");
  };

  const shouldShowTimer = showTimer && !timerExpired;

  return (
    <div className={`overview-block ${className ? className : ""}`}>
      <div className="title-head profile-slider-wrapper">
        <div className="title-text">
          <div className="main-head flex gap-2-5 flex-wrap">
            {cardTitleIcon && (
              <span className="icons-wrapper">{cardTitleIcon}</span>
            )}
            <h3 className="font-title-lg fw-700">{cardTitle}</h3>
            {shouldShowTimer && (
              <Tag variant="timer">
                {formatTime(timeLeft.hours)}h:
                {formatTime(timeLeft.minutes)}m:
                {formatTime(timeLeft.seconds)}s
              </Tag>
            )}
          </div>
          <div className="flex justify-between items-center mt-1 gap-2">
            <p className="font-title-xs fw-500">{cardDesc}</p>
            {seeAllBtn && data?.length ? (
              <div className="card-direction">
                <Button
                  {...(onClick ? { onClick } : { href })}
                  icon={<RightArrow />}
                  className="see-all-btn"
                  variant="custom"
                  onClick={seeAllClick}
                >
                  See all
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="overview-cards-wrapper mt-6">
        {isLoading ? (
          <Skeleton label={false} height={200} />
        ) : data?.length === 0 ? (
          <EmptyState className="overview-empty" />
        ) : (
          cardComponent
        )}
      </div>
    </div>
  );
}

export default OverviewBlock;
